import { render, staticRenderFns } from "./adherence.vue?vue&type=template&id=7323d473&"
import script from "./adherence.vue?vue&type=script&lang=js&"
export * from "./adherence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports